// extracted by mini-css-extract-plugin
export var btn = "week-switcher-module--btn--1207b";
export var btnHolder = "week-switcher-module--btn-holder--0a400";
export var weekSwitcher = "week-switcher-module--week-switcher--5d571";